import classNames from 'classnames'
import styles from './BaseModalContent.module.scss'
import type { BaseModalContentProps } from './types'

const BaseModalContent = ({ className, children }: BaseModalContentProps) => {
  return (
    <div
      className={classNames(styles['pintxo-modal__slot'], 'pintxo-scrollable-shadow', className)}
    >
      {children}
    </div>
  )
}
export default BaseModalContent
